// This is a rare instance where is okay to use process.env in the frontend,
// because the value that is hardcoded during the build is also valid at runtime.
// This will always be true in the new Consumer app, and always false in the old app.
const isNewConsumerApp = !!process.env.NEXT_PUBLIC_IS_NEXT_APP;

export default isNewConsumerApp;
